export default __webpack_public_path__ + "static/media/Astro_Sagittarius_White.c7b72f43.png";